import {MouseEvent, TouchEvent} from "react";

interface GetSlideFunctionAttributes {
    isDisabled: boolean,
    formattedDate: string,
    selectNewSearchDate: (selectedDate: string) => void
}

/**
 * Function which returns handle functions for single date slide
 */
export default function getSlideFunctions(attributes: GetSlideFunctionAttributes) {
    const {
        isDisabled,
        formattedDate,
        selectNewSearchDate,
    } = attributes

    const onClick = isDisabled ? null : () => {
        selectNewSearchDate(formattedDate)
    }

    return {
        onClick,
    }
}